export default __webpack_public_path__ + "static/media/Trust_Wallet.2bc7697d.svg";